module.exports = __webpack_public_path__ + "static/media/connectingArrowDown.2316bff5.svg";